// @avantia common-code
import { getFromWindowRef } from '@avantia/client-and-server-utilities';
import { logError } from '../clientLogging';

export function postScriptError(data: string | Record<string, any>, level: 'info' | 'warn' | 'error'): void {
  interface WinProps {
    postScriptError: HpPostScriptErrorFunction;
  }

  logError(data);

  const { postScriptError } = getFromWindowRef<WinProps>(['postScriptError']) || {};
  if (postScriptError) {
    postScriptError(data, level);
  }
}

export type HpPostScriptErrorFunction = (data: string | Record<string, any>, level: 'info' | 'warn' | 'error') => void;
